<template>
  <b-modal
    :visible="shown"
    size="lg"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @hide="handleClose"
    hide-footer>

    <div slot="modal-title">
      <h4 class="m-0">Known columns mapping</h4>
      <div class="title-description">
        Help us understand your data structure for more advanced insights
      </div>
    </div>

    <column-map
      v-if="shown"
      :meta="meta"
      :file="file"
      :project="project"
      @success="handleClose" />

  </b-modal>
</template>

<script>
  import ColumnMap from './ColumnMap';

	export default {
		name: 'ColumnMapModal',
    components: {ColumnMap},
    props: {
			shown: Boolean,
			file: Object,
			meta: Object,
			project: Object
    },
    methods: {
			handleClose() {
				this.$emit('close');
      }
    }
	};
</script>

<style scoped>
  .title-description {
    font-weight: normal;
    font-size: .8em;
  }
</style>
